import { AbstractEntityMapper } from '@pf/shared-services';
import {
    ProjectCreate,
    ProjectDto,
    ProjectRead,
    ProjectSearchParams,
} from '../../entities/project.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { ProjectMetadataMap } from './project.mapping-profile';

@Injectable()
export class ProjectMapper extends AbstractEntityMapper<
    ProjectRead,
    ProjectCreate,
    ProjectDto,
    ProjectSearchParams
> {
    constructor() {
        super(ProjectDto, PlatformWmsMapper, ProjectMetadataMap.symbols);
    }
}
